export default __webpack_public_path__ + "static/media/sketch.0f775524.png";